
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSubCategory1Grid extends Serenity.EntityGrid<CsSubCategory1Row, any> {
        protected getColumnsKey() { return CsSubCategory1Columns.columnsKey; }
        protected getDialogType() { return CsSubCategory1Dialog; }
        protected getIdProperty() { return CsSubCategory1Row.idProperty; }
        protected getInsertPermission() { return CsSubCategory1Row.insertPermission; }
        protected getLocalTextPrefix() { return CsSubCategory1Row.localTextPrefix; }
        protected getService() { return CsSubCategory1Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        
    }
}